
import LanguageSwitch from '@/UI/components/brand/LanguageSwitch.vue';

import PultLogo from '@/UI/components/brand/PultLogo.vue'
import {Component, Vue} from 'vue-property-decorator'
import LoginForm from '@/form/login/login'
import FormGroup from '@/UI/components/common/form/FormGroup.vue'
import {AuthStore} from '@/store/modules/Auth'
import {message} from 'ant-design-vue'
import {Input} from 'ant-design-vue'

@Component({
  components: {LanguageSwitch,
    FormGroup,
    PultLogo,
    'a-input': Input
  }
})
export default class Login extends Vue {
  form = new LoginForm();

  async submit(): Promise<void> {
    if (this.form.disabled) return;
    this.form.sendingRequest = true;
    try {
      const resp = await AuthStore.login(this.form.getFormData())
      //const cRoles: string[] = []
      if (resp.data.user) {
        const user = resp.data.user

        await AuthStore.setUser(user)
        sessionStorage.setItem('userData', JSON.stringify(user))
        //Vue.router.replace('/home')
      }
      if (resp.data.status) {
        window.location.replace(this.$route.query.redirect === 'register' ? '/#/register' : '/#/studios/index/0');
        window.location.reload();
        // message.success(resp.data.response)
        this.$notification.success({
          message: resp.data.user.name,
          description: resp.data.response
        })
      } else {
        message.error(resp.data.response)
      }

    } catch (e) {
      console.error(e.message);
    } finally {
      this.form.sendingRequest = false;
    }
  }
}
